import TableCell from '@material-ui/core/TableCell';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';

export const StyledTableCell = styled(TableCell)`
    border-left: 1px solid rgba(224, 224, 224, 1);
    padding: 0;
`;

export const StyledTestField = styled(TextField) <{ flex?: number | string }>`
    ${props => props.flex ? ('flex: ' + props.flex + ' !important') : ''}

    & fieldset {
        border: 0;
    }
`;

export const StyledDiv = styled.div`
    font-size: 12pt;
`;
